module.exports = __webpack_public_path__ + "static/media/HNT.0cd927d0.svg";